import './styles.scss/home.scss'

export default function Home(){

    return(
        <main className="home">
            <h1>Panda Wash</h1>
        </main>
    )
}